"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.reconcileInputs = reconcileInputs;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
function reconcileInputs() {
  return function (getState, dispatch) {
    const {
      formElement,
      inputStates
    } = getState();
    (0, _forEach.default)(inputStates).call(inputStates, (inputState, inputElement) => {
      if (!formElement.contains(inputElement)) {
        dispatch({
          payload: {
            inputElement
          },
          type: 'removeInputState'
        }, true);
      }
    });
  };
}